export enum StaffRoutes {
    all_staff = '/my_practice/staff',
    add_staff = '/my_practice/staff/add',
}
